<!-- 视频上传 -->
<template>
  <div>
    <transition v-if="isBoxShow1" name="el-zoom-in-bottom">
      <div class="box" v-if="isBoxShow1">
        <!-- 顶部盒子 -->
        <div class="top">
          <p ref="pRefs">上传进度</p>
          <h3> <span class="uploadtext" style="color:green;">{{ successList.length }}
            </span>
            个视频上传成功
            <span class="uploadtext" style="color:red"> {{ errorList.length }}
            </span>
            个视频上传失败
          </h3>
          <div class="top-r">
            <div class="el-button"></div>
            <div class="less" @click="$emit('isLessShowClick1', false, true)">
              <i class="el-icon-minus"></i>
            </div>
            <div class="cross" @click="cross"><i class="el-icon-circle-close"></i></div>
          </div>
        </div>

        <!-- 中间部分 -->
        <div class="middle">
          <button class="btn" @click="onBtn">+选择视频</button>
          <el-upload name='MultipartFile' class="upload-demo" :headers='config' :action="action" :data="query"
            :before-upload="onBeforeUpload" :on-preview="handlePreview" :on-remove="handleRemove"
            :on-success="handleSuccess" :on-progress="handleProgress" :on-change="onChange" :file-list="fileList"
            list-type="picture" :multiple='true' :auto-upload="true" :show-file-list='true'>
            <el-button ref="uploadRef" size="small" type="primary"></el-button>
            <div slot="tip" class="el-upload__tip">
              <h3>请注意！</h3>
              <p>1.请确认您拥有上传视频的著作权或版权，如有侵权行为，您将承担相应的法律责任。</p>
              <p> 2.视频分辨率≥200w像素，；单个文件≤1GB,格式限AVI、nAVI、ASF、WMV、MOV、MP4格式</p>
              <div></div>
            </div>
          </el-upload>
        </div>
        <!-- 底部 -->
        <div class="foot">
          <el-button @click="clear">清空上传失败项</el-button>
          <div style="width:146px;height:42px"></div>
          <!-- <el-button
          ref="btnEditRef"
          style="background-color:#ccc;color:#fff;"
          disabled
                            >去编辑视频</el-button> -->

        </div>
      </div>
    </transition>
    <!-- 最小化 -->
    <transition name="el-zoom-in-bottom">
      <div class="box2" v-if="isLessShow1">
        <el-button>＋选择视频</el-button>
        <div class="right">
          <div class="big" @click="$emit('isBigShowClick1', false, true)"><i class="el-icon-copy-document"></i></div>
          <div class="cross" @click="cross"><i class="el-icon-circle-close"></i></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from '@/utils/axios'
export default {
  props: {
    isBoxShow1: {
      type: Boolean,
      required: true,
      default: false
    },
    isLessShow1: {
      type: Boolean,
      required: true,
      default: false
    },
    feedType2: {
      type: Number,
      required: true,
      default: false
    }
  },
  created() {
    this.token = window.localStorage.getItem('token')
    // console.log(this.token);

  },
  data() {
    return {
      fileList: [],
      token: null,
      isFileShow: false,
      // action: "http://yun.yunshangzg.com:1008/upload/uploadVideo",
      action: `${axios.defaults.baseURL}/upload/uploadVideo`,
      query: {
        file: null,
        feedType: 2
      },  //接口参数
      goEdit: true,    //控制去编辑按钮禁用
      successList: [],//上传成功的列表
      errorList: [],//上传失败的列表
    }
  },
  methods: {
    cross() {
      this.$emit('update:isBoxShow1', false)
      this.$emit("yeye1", false)
    },
    // 自己定位一个按钮，把上传按钮覆盖，通过ref触发上传按钮（通过有无token判断）
    // 因为el-upload的上传按钮会自己打开本地文件选择器
    onBtn() {

      if (this.token) {
        this.$refs.uploadRef.$el.click()
      } else {
        return this.$message.error('请先登录')
      }
    },
    onChange(file, fileList) {
      this.getVideoCover(file)
      this.query.file = file.raw
      this.fileList = fileList;
      // console.log(fileList);
      // console.log(file);
    },
    onBeforeUpload(file) {

      if (['video/avi', 'video/navi', 'video/asf', 'video/wmv', 'video/mov', 'video/mp4'].indexOf(file.type) == -1) {
        this.$message.error('上传文件格式不正确!');
        return false;
      }
      const isLtGB = file.size / 1024 / 1024 / 1024 < 2;
      if (!isLtGB) {
        this.$message.error('您上传的视频需要2GB以内')
        return false
      }
      return true
    },
    handleRemove(file) {
      // console.log(file);
      this.fileList = fileList
      // 成功列表
      this.successList = fileList.filter(item => {
        return item.response.success == true
      })
      // 失败列表
      this.errorList = fileList.filter(item => {
        return item.response.success == false
      })
    },
    handlePreview(file, fileList) {
      this.fileList = fileList;
      // console.log(file);
      // console.log(fileList);
    },
    // 文件上传时的钩子
    handleProgress(event, file, fileList) {
      this.$refs.pRefs.innerHTML = '<div >上传中...</div>'
      this.fileList = fileList;
    },
    handleSuccess(response, file, fileList) {
      this.$refs.pRefs.innerHTML = '<div style="color:#09BA07;">上传成功</div>'

      if (file) {
        // 上传成功的文件列表
        if (file.response.success == true) {
          file.name += '上传成功'
        }
        // 上传失败的文件列表
        if (file.response.success == !true) {
          file.name += file.response.msg
        }
      }

      // 成功列表
      this.successList = fileList.filter(item => {
        return item.response.success == true
      })
      // 失败列表
      this.errorList = fileList.filter(item => {
        return item.response.success == false
      })

      // 如果成功列表长度大于一就解除按钮禁用
      if (this.successList.length > 0) {
        this.goEdit = false
      }

      this.fileList = fileList;
      // console.log(response);
      // console.log(file);
      // console.log(fileList);


    },
    clear() {
      // 删除上传失败的项
      // console.log(this.fileList);
      const newFileList = this.fileList.filter(item => {
        return item.response.success == true
      })
      // console.log(newFileList);
      this.fileList = newFileList
    },

    // 截取视频第一针
    getVideoCover(file) {
      this.$set(file, 'videoUrl', file.url); //备份视频源路径，用于后续预览展示

      const video = document.createElement("video") // 也可以自己创建video
      video.src = file.url // url地址 url跟 视频流是一样的
      //设置默认封面，videoDefCover 为预制的默认封面，不需要可去除或替换成自己的
      let canvas = document.createElement('canvas') // 获取 canvas 对象
      const ctx = canvas.getContext('2d'); // 绘制2d
      video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 2 // 第一帧

      video.oncanplay = () => {
        console.log(video.clientWidth, video.clientHeight);
        canvas.width = video.clientWidth ? video.clientWidth : 320; // 获取视频宽度
        canvas.height = video.clientHeight ? video.clientHeight : 320; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        // 转换成base64形式
        let _videoFirstimgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        console.log(_videoFirstimgsrc);
        this.$set(file, 'url', _videoFirstimgsrc);   //重置文件的url为当前截取的封面，用于 el-upload展示
        video.remove();
        canvas.remove();
      }
    },

    // 点击去编辑照片
    goEditVideo() {

    }
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  watch: {
    //监听父组件传过来的feedType变化，子组件跟着变化
    feedType2: {
      handler(newVal) {
        console.log(newVal)
        this.query.feedType = newVal
      },
      immediate: true,
    }
  },
  filters: {},
  components: {}
}
</script>

<style scoped lang='scss'>
// 按钮禁用
.diabled {
  background-color: #ccc !important;
}

//上传结果文字
.uploadtext {
  font-size: 18px !important;
  font-weight: 600 !important;
}

.box {
  width: 720px;
  height: 700px;
  border-radius: 20px 0 0 0;
  background-color: #fff;
  position: fixed;
  bottom: 40px;
  right: 0;
  z-index: 1111;

  .top {
    height: 80px;
    margin: 0 18px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      text-align: center;
      line-height: 22px;
      width: 64px;
      height: 22px;
      margin-right: -60px;
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #000000;
    }

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #666;
    }

    .top-r {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button {
        width: 121px;
        height: 46px;
        margin-right: 30px;
        background-color: #db3a3b;
        color: #fff;
      }

      .less {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      .cross {
        width: 20px;
        height: 20px;
      }
    }
  }

  // 中间样式
  .middle {
    width: 720px;
    height: 540px;
    padding: 0 20px;
    position: relative;

    .btn {
      position: absolute;
      top: -62px;
      left: 502px;
      width: 121px;
      height: 46px;
      margin-right: 30px;
      background-color: #db3a3b;
      color: #fff;
      border-radius: 5px;
      z-index: 99999;
    }

    .el-button {
      opacity: 0;
      position: absolute;
      top: -62px;
      left: 502px;
      width: 21px;
      height: 16px;
      margin-right: 30px;
      background-color: #db3a3b;
      color: #fff;
      font-size: 14px;
    }

    .el-upload__tip {
      height: 90px;
      border-bottom: 1px solid #ccc;

      h3 {
        font-size: 14px;
        color: #e73d4a;
      }

      p {
        margin-top: 5px;
        color: #808080;
      }
    }
  }

  // 底部
  .foot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 720px;
    height: 80px;
    border-top: 1px solid #ccc;

    // background-color: red;
    .el-button {
      height: 42px;
      width: 146px;

      &:nth-child(1) {

        &:focus,
        &:hover {
          color: #606266 !important;
          border-color: #ccc;
          background-color: #fff;
        }
      }

      &:nth-child(2) {
        background-color: #db3a3b;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}

// 给upload组件list设置滚动条
/deep/ .el-upload-list {
  overflow-y: auto;
  width: 700px;
  height: 400px;
}

// 最小化样式
.box2 {
  width: 720px;
  height: 100px;
  border-radius: 20px 0 0 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  .right {
    display: flex;

    .big {
      margin-right: 20px;
    }
  }

  .el-button {
    width: 121px;
    height: 46px;
    margin-right: 30px;
    background-color: #db3a3b;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contributor/components/videoUpload.vue